import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { openVkBuyModalWithSidebar } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.helpers';
import { EPaymentModalType } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.types';
import { getAbTrialPopup2Group, getAbTrialPopupGroup } from 'reactApp/modules/features/features.selectors';
import { Button } from 'reactApp/ui/Button/Button';
import Dialog from 'reactApp/ui/Dialog/Dialog';

import styles from './BannerOffer.css';
import { EBannerOfferTheme, Props } from './BannerOffer.types';
import { useBannerOfferCallback } from './hooks/useBannerOfferCallback';

export const BannerOffer = memo(function BannerOffer(props: Props): JSX.Element | null {
    const {
        product,
        onClose: handleClose,
        onClick: handleClick,
        onShow: handleShow,
        title,
        text,
        icon,
        button = 'Получить',
        id = EBannerOfferTheme.LIGHT,
    } = props;

    const abTrialPopup = useSelector((state) => getAbTrialPopupGroup(state));
    const abTrialPopup2 = useSelector((state) => getAbTrialPopup2Group(state));

    const { onClick, onClose, onShow } = useBannerOfferCallback({
        id,
        handleClose,
        handleClick,
        handleShow,
        product,
        groupAb: abTrialPopup2 || abTrialPopup,
    });

    useEffect(() => onShow(), []);

    if (abTrialPopup === 'B' && !abTrialPopup2) {
        openVkBuyModalWithSidebar({ productId: product.id, type: EPaymentModalType.trial });
        return null;
    }

    return (
        <Dialog open={true} onCancel={onClose} closeOnEscape className={styles.modal} closeOnDimmerClick>
            <section
                className={classNames({
                    [styles.root]: true,
                    [styles[`root_theme_${EBannerOfferTheme.LIGHT}`]]: true,
                })}
            >
                <div className={styles.iconBlock}>
                    <div className={styles.icon} style={{ backgroundImage: `url(${icon})` }} />
                </div>
                <h2 className={styles.title}>{title}</h2>
                <div className={styles.text}>{text}</div>
                <Button primary fluid onClick={onClick} size="big" theme="octavius" className={styles.button}>
                    {button}
                </Button>
            </section>
        </Dialog>
    );
});
